import React from "react";
import { Message, Icon } from "semantic-ui-react";
import { formatAmount, getMinimumAmountByDeliveryType } from "utilities/dist/helpers";

const InvoiceComponentTotals = ({ totals, company, delivery_type }) => {
    const minimumAmount = getMinimumAmountByDeliveryType(company, delivery_type);
    const isBelowMinimum = minimumAmount > 0 && Number(totals.total) < minimumAmount;

    return (
        <>
            SubTotal: <b>{formatAmount(totals.subTotal)}</b>
            <br />
            {totals.taxTotal > 0 && <span className="text-red">*</span>}Tax:{" "}
            <b>{formatAmount(totals.total - totals.subTotal)}</b>
            <br />
            Total: <b>{formatAmount(totals.total)}</b>
            {isBelowMinimum && (
                <Message
                    warning
                    size="tiny"
                    className="tp-10 no-print"
                    data-cy="invoice-minimum-warning"
                >
                    <Icon name="warning circle" />
                    This invoice total is below the {delivery_type} minimum of{" "}
                    {formatAmount(minimumAmount)}.
                </Message>
            )}
        </>
    );
};

export default InvoiceComponentTotals;
